import { trackAgentControl } from '@gonfalon/ai-configs/analytics';

export function trackAiSignupStarted(): void {
  const params = new URLSearchParams(window.location.search);
  const source = params.get('utm_source') ?? 'direct';
  const referrer = params.get('referer') ?? (document.referrer || 'none');
  trackAgentControl('AgentControl Signup Started', { source, referrer });
}

export function trackAiSignupCompleted(attributes: { email: string }): void {
  trackAgentControl('AgentControl Signup Completed', {
    email: attributes.email,
    referrer: window.location.href,
    timestamp: Date.now(),
  });
}
